<template>
<layout-content>
  <template #toolbar>
    <period-time
      :query="query"
      :start-date-picker-options="startDatePickerOptions"
      :end-date-picker-options="endDatePickerOptions"
      :show-options="showOptions"
    >
      <el-select v-model="query.siteIds[0]" size="small" style="width: 150px;">
        <el-option
          v-for="item in filterSites"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>

      <completed-query v-model="query.isAuditCompleted" :is-show-fuse="false" @change="onAuditCompletedChanged" />

      <el-button
        :disabled="canNotSearch"
        type="orange"
        size="small"
        icon="el-icon-search"
        @click="onSearchBtnClick"
      >查询</el-button>
    </period-time>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <el-radio-group v-model="currentRadio" size="small" @change="sortData(integration, query.granularity)">
          <el-radio-button v-for="(item, i) in defaultRadioOpt" :key="i" :label="item.id">{{item.name}}</el-radio-button>
        </el-radio-group>
      </template>

      <section class="main-wrapper">
        <div class="air">
          <timing-analysis-chart
            ref="chart"
            :current-radio="currentRadio"
            :current-radio-name="defaultRadioOptMap[currentRadio].name"
            :granularity="query.granularity"
            :data="lineChart"
            :no-data-reason-map="noDataReasonMap"
          />
        </div>
        <div class="table">
          <el-table
            ref="table"
            :data="tableList"
            height="100%"
            border
            stripe
            highlight-current-row
            header-row-class-name="custom-table-header"
            class="custom-table no-inner-border double-click-table"
            style="width: 100%"
          >
            <el-table-column
              v-for="(item, i) in tableHeader"
              :key="i"
              :label="`${item.id === 'count' || item.id === 'type' || item.id === 'aqi' ? item.name : item.name + (item.name === 'CO' ? ' mg/m3' : ' μg/m3')}`"
              :prop="item.id"
            >
              <template slot-scope="{row}">
                {{row[item.id] && row[item.id] !== '--' ? (item.id === 'type' ? row[item.id] : Number(row[item.id]).toFixed(2)) : '--'}}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="month">
          <div>
            <timing-pie-chart
              ref="grade"
              :data="statisticsData.gradeScale"
              name="空气质量等级占比"
            />
          </div>
          <div>
            <timing-pie-chart
              ref="primary"
              :data="statisticsData.primaryScale"
              name="首要污染物占比"
            />
          </div>
          <div>
            <timing-pie-chart
              ref="factor"
              :data="statisticsData.factorScale"
              name="六项污染物贡献率"
            />
          </div>
        </div>
      </section>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import PeriodTime from '../../../../components/Data/PeriodTime'
import BaseFactorData from '../../../BaseFactorData'
import TimingAnalysisChart from '../../../../components/Data/TimingAnalysisChart'
import TimingPieChart from '../../../../components/Data/TimingPieChart'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'
import {DEFAULT_RADIO_OPT} from './defaulData'
import Constant from '../../../../model/Constant'

export default {
  name: 'TimingAnalysis',
  routeInfo: {
    label: '时序分析',
    icon: 'fa fa-users'
  },
  extends: BaseFactorData,
  components: {PeriodTime, TimingAnalysisChart, TimingPieChart},
  data () {
    return {
      query: {
        factorIds: [1001, 1003, 1005, 1006, 1007, 1008],
        granularity: 'hour',
        isSiteMerge: false,
        isTimeMerge: false,
        isAuditCompleted: false
      },
      currentRadio: 'all',
      defaultRadioOpt: DEFAULT_RADIO_OPT,
      originalData: {},
      integration: {},
      airData: {},
      lineChart: {},
      tableHeader: [],
      tableList: [],
      statisticsData: {
        gradeScale: [],
        primaryScale: [],
        factorScale: []
      },
      noDataList: Object.freeze([])
    }
  },
  computed: {
    startDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() > new Date(this.query.endTime)
      }
    },
    endDatePickerOptions () {
      return {
        disabledDate: time => time.getTime() < new Date(this.query.beginTime)
      }
    },
    showOptions () {
      return ['hour', 'day', 'month']
    },
    radioOpt () {
      return [{
        id: 'all',
        name: '综合'
      }]
    },
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false)
      ]
    },
    minSiteSelectNumber: () => 1,
    completeAllData: () => false,
    valueProp: () => 'value',
    _siteDeviceCategoryConfig () {
      let bit = 0
      return this.siteDeviceCategoryConfig.reduce((map, deviceCategoryConfig) => {
        let {categoryId} = deviceCategoryConfig
        let num = 1 << bit

        if (!map.map[categoryId]) {
          map.map[categoryId] = {
            bit: bit,
            filter: deviceCategoryConfig.filter
          }
          map.total |= num
          map.min |= num & (-deviceCategoryConfig.required)
          bit++
        }

        return map
      }, {
        map: {},
        total: 0,
        min: 0
      })
    },
    _filterSites () {
      let {profileSiteDevices} = this

      if (profileSiteDevices.length === 0) {
        return []
      }

      let {_siteDeviceCategoryConfig: {map: deviceCategoryMap, total, min}, profileSiteMap} = this

      return Object.values(profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let site = profileSiteMap[siteId]

        if (!site) {
          return map
        }

        let deviceCategoryConfig = deviceCategoryMap[siteDevice.categoryId]

        if (deviceCategoryConfig) {
          let {filter} = deviceCategoryConfig
          let siteDeviceFactors = filter instanceof Function
            ? filter(siteDevice.siteDeviceFactors)
            : [...siteDevice.siteDeviceFactors]

          if (siteDeviceFactors.length > 0) {
            let {bit} = deviceCategoryConfig
            let tmpSite = map[siteId]

            if (!tmpSite) {
              tmpSite = map[siteId] = {
                id: siteId,
                name: site.name,
                total: 0,
                devices: []
              }
            }

            tmpSite.total |= 1 << bit
            tmpSite.devices.push({
              ...siteDevice,
              siteDeviceFactors
            })
          }
        }

        return map
      }, {})).filter(site => (site.total & total) >= min)
    },
    filterSites () {
      return this._filterSites
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    isNoSelectedSites () {
      return this.query.siteIds.length === 0
    },
    canNotSearch () {
      return this.isNoSelectedSites
    },
    // grade状态码
    gradeLevel () {
      return {
        1: '优',
        2: '良',
        3: '轻度污染',
        4: '中度污染',
        5: '重度污染',
        6: '严重污染'
      }
    },
    defaultRadioOptMap () {
      return this.defaultRadioOpt.reduce((map, el) => {
        map[el.id] = el
        return map
      }, {})
    },
    noDataReasonMap () {
      const {filterSiteMap} = this
      return this.noDataList.reduce((map, noData) => {
        const {siteId} = noData
        const site = filterSiteMap[siteId]

        if (site) {
          const {siteDeviceId} = noData
          const siteDevice = site.devices.find(siteDevice => siteDevice.id === siteDeviceId)

          if (siteDevice) {
            const dataTime = `${noData.dataTime}:00:00`
            siteDevice.siteDeviceFactors.reduce((map, siteDeviceFactor) => {
              map[`${siteId}-${siteDeviceFactor.factorId}-${dataTime}`] = noData
              return map
            }, map)
          }
        }
        // map[`${noData.siteId}-${noData.siteDeviceId}-${noData.dataTime}:00:00`] = noData
        return map
      }, {})
    }
  },
  methods: {
    onAuditCompletedChanged () {
      this.afterSetSiteIds()
    },
    renderData () {
      setTimeout(() => {
        let dataRenders = this.getDataRenders()

        if (dataRenders) {
          dataRenders.forEach(dataRender => dataRender.render())
        }
      }, 0)
    },
    getData () {
      if (this.query.siteIds.length === 0) return
      this.changeLoadStatus(true)
      let query = this.query
      let queryData = {
        beginTime: query.beginTime,
        endTime: query.endTime,
        isAuditCompleted: query.isAuditCompleted,
        siteIds: query.siteIds
      }

      Promise.all([this.$api.Aqi.getAQIData(Object.assign(queryData, {
        factorIds: query.factorIds,
        isSiteMerge: query.isSiteMerge,
        isTimeMerge: query.isTimeMerge,
        granularity: query.granularity === 'hour' ? 1 : 24
      })), this.$api.StatisticalAnalysis.getOtherData({
        siteIds: query.siteIds,
        beginTime: query.beginTime,
        endTime: query.endTime,
        isAuditCompleted: query.isAuditCompleted,
        factorIds: ['1002', '1004', '1009'],
        granularity: query.granularity
      }), this.$api.Aqi.getComposite(Object.assign(queryData, {
        factorIds: query.factorIds,
        isSiteMerge: query.isSiteMerge,
        granularity: query.granularity === 'hour' ? 1 : (query.granularity === 'day' ? 24 : '')
      })), this.$api.NoData.getNoDataListBySite(queryData)]).then(([aqiData, otherData, allData, noDataList]) => {
        this.originalData = Object.freeze({
          aqiData: aqiData,
          otherData: otherData,
          allData: allData
        })

        this.integrationData(aqiData, otherData, allData, queryData)
        this.setNoDataList(noDataList)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setNoDataList (noDataList) {
      const {NO_DATA_REASON_MAP} = Constant

      this.noDataList = Object.freeze(noDataList.map(noData => {
        let {cause} = noData
        const noDataReasons = []

        while (cause > 0) {
          const bin = -cause & cause
          cause ^= bin
          const noDataReason = NO_DATA_REASON_MAP[bin]

          if (noDataReason) {
            noDataReasons.push(noDataReason.label)
          }
        }

        return {
          ...noData,
          reason: noDataReasons.join(',')
        }
      }))
    },
    integrationData (aqiData, otherData, allData, queryData) {
      let {query} = this
      Promise.all([this.formatAqiData(aqiData, Object.assign(queryData, {
        factorIds: query.factorIds,
        isSiteMerge: query.isSiteMerge,
        isTimeMerge: query.isTimeMerge,
        granularity: query.granularity === 'hour' ? 1 : 24
      })), this.formatOtherData(otherData, {
        siteIds: query.siteIds,
        beginTime: query.beginTime,
        endTime: query.endTime,
        isAuditCompleted: query.isAuditCompleted,
        factorIds: [1002, 1004, 1009],
        granularity: query.granularity
      }), this.formatAllData(allData, Object.assign(queryData, {
        factorIds: query.factorIds,
        isSiteMerge: query.isSiteMerge,
        granularity: query.granularity === 'hour' ? 1 : (query.granularity === 'day' ? 24 : '')
      }))]).then(([aqi, other, all]) => {
        let data = {}

        for (let key in aqi) {
          data[key] = {
            ...aqi[key],
            ...other[key],
            ...all[key]
          }
        }

        this.airData = Object.freeze(aqi)
        this.integration = Object.freeze(data)
        this.sortData(data, query.granularity)
      })
    },
    formatMonthData (data) {
      let {query: {factorIds, granularity}, gradeLevel} = this
      let defaulGradeMap = {}
      for (let key in gradeLevel) {
        defaulGradeMap[key] = {
          level: gradeLevel[key],
          name: gradeLevel[key],
          grade: key,
          count: 0
        }
      }
      // console.log(data, factorIds, granularity)
      let gradeTemp = {}
      let primaryTemp = {}
      let factorTemp = {}

      Object.values(data).forEach(el => {
        let primary = el.primaryPollutant.split(',')
        primary.forEach(item => {
          if (!primaryTemp[item]) {
            primaryTemp[item] = {
              name: item,
              count: 0
            }
          }

          primaryTemp[item].count += 1
        })

        if (!gradeTemp[el.grade]) {
          gradeTemp[el.grade] = {
            name: gradeLevel[el.grade],
            grade: el.grade,
            count: 0
          }
        }
        gradeTemp[el.grade].count += 1

        factorIds.forEach(item => {
          if (!factorTemp[item]) {
            factorTemp[item] = {
              factorId: item,
              name: el[item].rootFactorId,
              count: 0
            }
          }

          if (granularity === 'hour') {
            if (el[item].rootFactorId !== 'H8O3') {
              factorTemp[item].count += el[item].iaqi === '--' ? 0 : el[item].iaqi
            }
          } else {
            if (el[item].rootFactorId !== 'O3') {
              factorTemp[item].count += el[item].iaqi === '--' ? 0 : el[item].iaqi
            }
          }
        })
      })

      let gradeScale = Object.values(Object.assign(defaulGradeMap, gradeTemp)).map(el => {
        return {
          ...el,
          value: el.count === 0 ? 0 : Number(el.count / Object.values(data).length * 100).toFixed(2)
        }
      })

      let primaryScale = Object.values(primaryTemp).map(el => {
        return {
          ...el,
          value: el.count === 0 ? 0 : Number(el.count / Object.values(data).length * 100).toFixed(2)
        }
      })

      let factorAvg = Object.values(factorTemp).map(el => {
        return {
          ...el,
          avg: el.count === 0 ? 0 : Number(el.count / Object.values(data).length)
        }
      })
      let factorTotal = factorAvg.reduce((acc, el) => {
        acc += el.avg === 0 ? 0 : Number(el.avg)
        return acc
      }, 0)

      let factorScale = Object.values(factorAvg).map(el => {
        return {
          ...el,
          value: el.avg === 0 ? 0 : Number(el.avg / factorTotal * 100).toFixed(2)
        }
      })

      this.statisticsData = {
        factorScale: factorScale,
        primaryScale: primaryScale,
        gradeScale: gradeScale
      }

      setTimeout(() => {
        this.$refs['grade'].render()
        this.$refs['primary'].render()
        this.$refs['factor'].render()
      }, 100)
    },
    sortData (data, granularity) {
      let defaultRadioOpt = JSON.parse(JSON.stringify(this.defaultRadioOpt))
      let {factorMap, query: {siteIds: [siteId]}} = this
      let tableHeader = defaultRadioOpt.map(el => {
        if (el.id !== 'all') {
          return {
            id: el.id,
            name: el.name
          }
        }
      }).filter(Boolean)
      let tableList = []
      let lineChartSeries = tableHeader.map(el => {
        return {
          name: '',
          type: 'line',
          symbol: 'none',
          data: []
        }
        // if (this.currentRadio === 'all') {
        //   return {
        //     name: '',
        //     type: 'line',
        //     symbol: 'none',
        //     data: []
        //   }
        // } else if (el.id === this.currentRadio) {
        //   return {
        //     name: '',
        //     type: 'line',
        //     symbol: 'none',
        //     data: []
        //   }
        // }
      }).filter(Boolean)

      if (granularity !== 'month') {
        let maxData = {
          type: '最大值'
        }
        let minData = {
          type: '最小值'
        }
        let totalData = {}
        let xAxisData = []

        Object.values(data).forEach(el => {
          xAxisData.push(el.dataTime)
          tableHeader.forEach((item, i) => {
            let key = item.id
            if (key === 'count' || key === 'aqi') {
              lineChartSeries[i].name = item.name
            } else if (typeof el[key] === 'object') {
              lineChartSeries[i].name = el[key].rootFactorId
              item.name = el[key].rootFactorId
            } else {
              lineChartSeries[i].name = factorMap[key].name
            }
            // if (lineChartSeries[this.currentRadio !== 'all' ? 0 : i].name === '') {
            //   if (key === 'count' || key === 'aqi') {
            //     lineChartSeries[this.currentRadio !== 'all' ? 0 : i].name = item.name
            //   } else if (typeof el[key] === 'object') {
            //     lineChartSeries[this.currentRadio !== 'all' ? 0 : i].name = el[key].rootFactorId
            //     item.name = el[key].rootFactorId
            //   } else {
            //     lineChartSeries[this.currentRadio !== 'all' ? 0 : i].name = factorMap[key].name
            //   }
            // }

            if (!maxData[key]) {
              maxData[key] = ''
            }
            if (!minData[key]) {
              minData[key] = ''
            }
            if (!totalData[key]) {
              totalData[key] = 0
            }
            if (typeof el[key] === 'object') {
              let val = el[key] ? el[key].value : 0
              maxData[key] = this.setMaxData(maxData[key], val)
              minData[key] = this.setMinData(minData[key], val)
              totalData[key] += Number(val === '--' ? 0 : val)

              // if (this.currentRadio === 'all') {
              lineChartSeries[i].data.push({
                dataTime: el.dataTime,
                value: (el[key].value !== '--' && el.hasOwnProperty(key) ? Number(el[key].value).toFixed(2) : '--') || '--',
                id: key,
                siteId
              })
              // }
            } else {
              let val = el[key] ? el[key] : 0
              maxData[key] = this.setMaxData(maxData[key], val)
              minData[key] = this.setMinData(minData[key], el[key])
              totalData[key] += Number(val === '--' ? 0 : val)

              // if (this.currentRadio === 'all') {
              lineChartSeries[i].data.push({
                dataTime: el.dataTime,
                value: (el[key] !== '--' && el.hasOwnProperty(key) ? Number(el[key]).toFixed(2) : '--') || '--',
                id: key,
                siteId
              })
              // }
            }

            // if (this.currentRadio !== 'all' && item.name === lineChartSeries[0].name) {
            //   if (typeof el[key] === 'object') {
            //     lineChartSeries[0].data.push({
            //       dataTime: el.dataTime,
            //       value: (el[key].value !== '--' && el.hasOwnProperty(key) ? Number(el[key].value).toFixed(2) : '--') || '--'
            //     })
            //   } else {
            //     lineChartSeries[0].data.push({
            //       dataTime: el.dataTime,
            //       value: (el[key] !== '--' && el.hasOwnProperty(key) ? Number(el[key]).toFixed(2) : '--') || '--'
            //     })
            //   }
            // }
          })
        })

        tableList.push(maxData)
        tableList.push(minData)
        let avgData = {
          type: '平均值'
        }
        for (let key in totalData) {
          avgData[key] = totalData[key] !== '--' ? totalData[key] / Object.values(data).length : '--'
        }
        tableList.push(avgData)

        this.tableHeader = Object.freeze([{
          id: 'type',
          name: '类型'
        }].concat(tableHeader))

        this.lineChart = Object.freeze({
          dataTime: xAxisData,
          series: lineChartSeries
        })
        this.tableList = Object.freeze(tableList)
      } else {
        // console.log(data, defaultRadioOpt)
        let defaulAqiData = tableHeader.reduce((map, el) => {
          let key = el.id
          if (key === 'count' || key === 'aqi') {
            map[key] = 0
          } else {
            map[key] = 0
            map[key + 'name'] = ''
          }

          return map
        }, {})
        // console.log(defaulAqiData)
        let xAxisData = []
        let monthData = Object.values(data).reduce((map, el) => {
          let date = new Date(el.dataTime).format('YYYY/MM')
          if (!map[date]) {
            map[date] = {
              dataTime: date,
              days: 0,
              ...defaulAqiData
            }
          }

          map[date].days += 1

          tableHeader.forEach(item => {
            let key = item.id
            if (typeof el[key] === 'object') {
              map[date][key] += el[key].value === '--' ? 0 : Number(el[key].value)
              map[date][key + 'name'] = el[key].rootFactorId
            } else {
              map[date][key] += !el[key] || el[key] === '--' ? 0 : Number(el[key])
              map[date][key + 'name'] = factorMap[key] ? factorMap[key].name : item.name
            }
          })

          return map
        }, {})
        // console.log(monthData)
        let avgData = {}
        let maxData = {}
        let minData = {}
        let totalData = {}

        Object.values(monthData).forEach(el => {
          xAxisData.push(el.dataTime)
          tableHeader.forEach((item, i) => {
            let key = item.id
            if (key === 'count' || key === 'aqi') {
              lineChartSeries[i].name = item.name
            } else if (typeof el[key] === 'object') {
              lineChartSeries[i].name = el[key].rootFactorId
              item.name = el[key].rootFactorId
            } else {
              lineChartSeries[i].name = factorMap[key].name
            }

            if (!maxData[key]) {
              maxData[key] = ''
            }
            if (!minData[key]) {
              minData[key] = ''
            }
            if (!totalData[key]) {
              totalData[key] = 0
            }

            let avg = el[key] === 0 ? '--' : el[key] / el.days
            totalData[key] += el[key] === 0 ? 0 : el[key] / el.days
            maxData[key] = this.setMaxData(maxData[key], avg)
            minData[key] = this.setMinData(minData[key], avg)

            lineChartSeries[i].data.push({
              dataTime: el.dataTime,
              value: avg === '--' ? '--' : Number(avg).toFixed(2)
            })
          })
        })
        let accData = Object.values(totalData).reduce((acc, el) => {
          acc += el
          return acc
        }, 0)

        for (let key in totalData) {
          avgData[key] = totalData[key] === 0 ? '--' : Number(totalData[key] / accData * 100).toFixed(2)
        }

        tableList.push({type: '最大值', ...maxData})
        tableList.push({type: '最小值', ...minData})
        tableList.push({type: '平均值', ...avgData})

        this.tableList = Object.freeze(tableList)
        this.lineChart = Object.freeze({
          dataTime: xAxisData,
          series: lineChartSeries
        })
      }

      setTimeout(() => {
        this.$refs['chart'].render()
      }, 10)
    },
    setMaxData (x, y) {
      if (x === '' || x === '--') {
        return y
      }
      return x > y ? x : y
    },
    setMinData (x, y) {
      if (x === '' || x === '--') {
        return y
      }

      return x > y ? y : x
    },
    formatAllData (data, query) {
      let {granularity} = query

      let tempData = data.reduce((map, el) => {
        let date = granularity === 1 ? new Date(el.dataTime + ':00:00').format('YYYY/MM/DD HH:mm:ss') : new Date(el.dataTime).format('YYYY/MM/DD HH:mm:ss')
        if (!map[date]) {
          map[date] = {
            dataTime: date,
            count: ''
          }
        }

        let value = Number(Number.isFinite(el.value) ? Number(el.value.toFixed(2)) : 0)
        map[date].count = Number(Number(map[date].count) + value).toFixed(2)

        return map
      }, {})

      return tempData
    },
    formatAqiData (data, query) {
      let {granularity, factorIds} = query
      let {factorMap} = this
      let defaultPollutantData = factorIds.concat([1002, 1004, 1009]).reduce((map, el) => {
        map[el] = {
          factorId: el,
          value: '--',
          rootFactorId: factorMap[el].name,
          iaqi: '--'
        }

        if (granularity === 1) {
          // if (factorMap[el].name === 'PM10') {
          //   map[el].rootFactorId = 'PM10_24H'
          // }
          //
          // if (factorMap[el].name === 'PM2.5') {
          //   map[el].rootFactorId = 'PM2.5_24H'
          // }
        } else {
          if (factorMap[el].name === 'O3') {
            map[el].rootFactorId = 'H8O3'
          }
        }

        return map
      }, {})
      let beginTS = new Date(data[0].dataTime).getTime()
      let endTS = new Date(data[data.length - 1].dataTime).getTime()
      let tsStep = granularity * 60 * 60000
      let dateData = {}

      for (let ts = beginTS; ts <= endTS; ts += tsStep) {
        let date = new Date(ts).format('YYYY/MM/DD HH:mm:ss')
        dateData[date] = {
          dataTime: new Date(ts).format('YYYY/MM/DD HH:mm:ss'),
          aqi: '--',
          grader: '--',
          ...defaultPollutantData
        }
      }

      if (!data.length) {
        return dateData
      }

      data.forEach(el => {
        let {dataTime} = el
        let ts = new Date(dataTime).format('YYYY/MM/DD HH:mm:ss')

        if (!el.pollutantData || el.pollutantData.length === 0) {
          dateData[ts] = Object.assign(el, defaultPollutantData)
        } else {
          let pollutantDataMap = el.pollutantData.reduce((map, item) => {
            if (granularity !== 1 && item.rootFactorId === 'O3') {
              return map
            }
            map[item.factorId] = item
            return map
          }, {})
          dateData[ts] = Object.assign(el, Object.assign(defaultPollutantData, pollutantDataMap))
        }
      })
      this.formatMonthData(dateData)

      return dateData
    },
    formatOtherData (data, query) {
      if (!data.length) return
      let {factorIds, granularity} = query
      let defaultData = factorIds.reduce((map, el) => {
        map[el] = '--'
        return map
      }, {})

      let temp = data[0].data.reduce((map, el) => {
        let date = granularity === 'hour' ? new Date(el.dataTime + ':00:00').format('YYYY/MM/DD HH:mm:ss') : new Date(el.dataTime).format('YYYY/MM/DD HH:mm:ss')
        if (granularity === 'month') {
          date = new Date(el.dataTime.replace(/年|月/g, '-') + '01 00:00:00').format('YYYY/MM/DD HH:mm:ss')
        }
        map[date] = Object.assign(el, {dataTime: date, ...defaultData})
        return map
      }, {})

      return temp
    }
  }
}
</script>

<style lang="scss" scoped>
.main-wrapper {
  width: 100%;
  height: 120%;
  display: grid;
  grid-template-columns: 100%;
  grid-gap: 5px;

  > div {
    width: 100%;
    height: 400px;
  }

  .table {
    height: 170px;
  }

  .month {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 100%;
    grid-gap: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/07TimingAnalysis/index.vue